<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
    <div class="tit">
      <h1>Sua solicitação foi cancelada</h1>
      <p>Você será redirecionado de volta para o site em instantes...</p>     
    </div>
  </div>
</template>

<script>
export default {
  created() {
    setTimeout(function() {
      window.location.href = process.env.LP_URL
    }, 5000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/CanceledStep.vue